import React from "react";
import useMediaQuery from '@mui/material/useMediaQuery';
import { HomeMenu } from "../Home/HomeMenu";
import { HomeBottomNavigation } from "../Home/HomeBottomNavigation";
import { Home } from "../Home";
import { ROUTES_PATH } from "../../utils/Consts";
import { Categories } from "../Categories";
import { Route, Routes } from "react-router-dom";
import Box from '@mui/material/Box';
import { HomePrivacyPolicies } from "../Home/HomePrivacyPolicies";
import { HomeTermsAndConditions } from "../Home/HomeTermsAndConditions";
import { HomeFooter } from "../Home/HomeFooter";
import AdminLogin from "../Admin/Login";
import AdminLayout from "../Admin/Layout";
import Dashboard from "../Admin/Dashboard";
import CategoriesManager from "../Admin/Categories";
import SubCategoriesManager from "../Admin/SubCategories";
import ProductsManager from "../Admin/Products";
import AdminChat from "../Admin/Chat";
import ProtectedRoute from "../Admin/ProtectedRoute";

function AppUI() {
    const matches = useMediaQuery('(min-width:600px)');
    
    return (
        <Routes>
            {/* Rutas públicas del sitio web */}
            <Route path={ROUTES_PATH.HOME} element={
                <div>
                    {matches ? <HomeMenu /> : <HomeBottomNavigation />}
                    <Box component="main" sx={{
                        marginTop: { xs: 0, sm: '130px',md: '130px', lg: '130px', xl: '130px' },
                        marginLeft: { xs: 0, sm: 0, md: '7%', lg: '7%', xl: '5%' }
                    }}>
                        <Home />
                    </Box>
                    <HomeFooter />
                </div>
            } />
            <Route path={`${ROUTES_PATH.CATEGORIES}/:categoryId`} element={
                <div>
                    {matches ? <HomeMenu /> : <HomeBottomNavigation />}
                    <Box component="main" sx={{
                        marginTop: { xs: 0, sm: '130px',md: '130px', lg: '130px', xl: '130px' },
                        marginLeft: { xs: 0, sm: 0, md: '7%', lg: '7%', xl: '5%' }
                    }}>
                        <Categories />
                    </Box>
                    <HomeFooter />
                </div>
            } />
            <Route path={ROUTES_PATH.PRIVACYPOLICY} element={
                <div>
                    {matches ? <HomeMenu /> : <HomeBottomNavigation />}
                    <Box component="main" sx={{
                        marginTop: { xs: 0, sm: '130px',md: '130px', lg: '130px', xl: '130px' },
                        marginLeft: { xs: 0, sm: 0, md: '7%', lg: '7%', xl: '5%' }
                    }}>
                        <HomePrivacyPolicies />
                    </Box>
                    <HomeFooter />
                </div>
            } />
            <Route path={ROUTES_PATH.TERMSANDCONDITIONS} element={
                <div>
                    {matches ? <HomeMenu /> : <HomeBottomNavigation />}
                    <Box component="main" sx={{
                        marginTop: { xs: 0, sm: '130px',md: '130px', lg: '130px', xl: '130px' },
                        marginLeft: { xs: 0, sm: 0, md: '7%', lg: '7%', xl: '5%' }
                    }}>
                        <HomeTermsAndConditions />
                    </Box>
                    <HomeFooter />
                </div>
            } />
            
            {/* Ruta de login del admin (pública) */}
            <Route path={ROUTES_PATH.ADMIN_LOGIN} element={<AdminLogin />} />
            
            {/* Rutas protegidas del admin */}
            <Route path="/admin" element={
                <ProtectedRoute>
                    <AdminLayout />
                </ProtectedRoute>
            }>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="categories" element={<CategoriesManager />} />
                <Route path="subcategories" element={<SubCategoriesManager />} />
                <Route path="products" element={<ProductsManager />} />
                <Route path="chat" element={<AdminChat />} />
            </Route>
            
            {/* Ruta por defecto */}
            <Route path={ROUTES_PATH.ALL} element={
                <div>
                    {matches ? <HomeMenu /> : <HomeBottomNavigation />}
                    <Box component="main" sx={{
                        marginTop: { xs: 0, sm: '130px',md: '130px', lg: '130px', xl: '130px' },
                        marginLeft: { xs: 0, sm: 0, md: '7%', lg: '7%', xl: '5%' }
                    }}>
                        <Home />
                    </Box>
                    <HomeFooter />
                </div>
            } />
        </Routes>
    )
}

export { AppUI };